import { AssetIndexName } from '@imcc/transport';
import {
  FilterTabState,
  initialState as initialTabState,
} from './filter-tab-state';

export const initialState = Object.freeze({
  indexName: AssetIndexName.IMAGE,
  tabs: Object.values(AssetIndexName).reduce<
  { [key in AssetIndexName]: FilterTabState }
  >(
    (acc, index) => ({
      ...acc,
      [index]: { ...initialTabState },
    }),
    {} as any,
  ),
});

export class FilterState {
  indexName: AssetIndexName;

  tabs: { [key in AssetIndexName]: FilterTabState };
}
